import config  from '../configFile';
export default config.baseUrl;
